import { render } from "./forbidden.vue?vue&type=template&id=0bea8b07"
const script = {}

import "./forbidden.vue?vue&type=style&index=0&id=0bea8b07&lang=css"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__